import { useState } from 'react';
import { Button, Skeleton, Spinner, Text } from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';
import { IEditProfile, useEditProfile } from '../firebase';

const Skill = ({
    isEditing,
    isLoading,
    profileId,
    setIsEditing,
    skill,
    strengths,
    tools
}: {
    isEditing: boolean;
    isLoading: boolean;
    profileId: string;
    setIsEditing: Function;
    skill: string;
    strengths: string[];
    tools: string[];
}) => {
    const [isSpinning, setIsSpinning] = useState(false);
    const accessToken = sessionStorage.getItem('accessToken') ?? '';
    const { mutate: edit } = useEditProfile(profileId);

    const removeSkill = (skillToBeRemoved: string, isStrength: boolean = false) => {
        const newSkills = isStrength
            ? strengths.filter((strength: string) => strength !== skillToBeRemoved)
            : tools.filter((tool: string) => tool !== skillToBeRemoved);
        const editedData: IEditProfile = {
            accessToken,
            data: isStrength ? { strengths: newSkills } : { tools: newSkills }
        };
        // TODO:leira must refresh data
        // why does it take so long to get a response?
        setIsSpinning(true);
        edit(editedData, {
            onSuccess: () => {
                // why doesn't the date refresh? how can I make the list refresh with the new data?
                console.log('successfully removed tool!!');
                setIsEditing(false);
                setIsSpinning(false);
            },
            onError: (error) => {
                console.log('removing tool failed: ', error);
            }
        });
    };

    return (
        <Skeleton
            isLoaded={!isLoading}
            padding={'7px 0'}
            key={skill}
            display="flex"
            justifyContent="space-between"
            alignItems="baseline"
        >
            <Text mb="1">{skill}</Text>
            {isEditing && (
                <Button
                    color="red"
                    pl={0}
                    pr={0}
                    padding={0}
                    background="none"
                    display="flex"
                    role="button"
                    aria-label={`remove ${skill}`}
                    onClick={() => removeSkill(skill)}
                >
                    {isSpinning ? <Spinner /> : <DeleteIcon />}
                </Button>
            )}
        </Skeleton>
    );
};

export default Skill;
